<template>
	<div class="apply-content" v-if="applyStatus!='audited'">
		<div class="apply-tip">
			<div class="tip-title">{{tipTitle}}</div>
			<div class="tip-text" v-show='isShowApplyStatusText'>{{applyStatusText}}</div>
		</div>
		<el-form class="apply-form" :style="{height:formHeight}" v-if='isShowForm' ref="applyForm" :model="applyForm" :rules="applyFormRules">
			<el-form-item class="form-item" v-for="item in loginLimitApplySettingList" :label="item.showName" :prop="item.selectedVal">
				<!--crm type 0:商城选项 1:文本输入框 2：整数输入框 3：小数输入框 4：日期选择框 5：数据字典下拉框 6：多选下拉框 7：数据映射) -->

				<!-- 多选下拉 -->
				<el-select filterable v-if="item.type == 6" v-model="applyForm[item.selectedVal]" multiple :placeholder="item.placeholder">
					<el-option v-for="opItem in item.dictionaryList" :key="opItem.dictionaryName" :label="opItem.dictionaryName" :value="opItem.dictionaryName">
					</el-option>
				</el-select>

				<!-- 单选下拉 -->
				<el-select filterable v-else-if="item.type == 5 || ['salesman', 'customerChannel', 'gender'].includes(item.selectedVal)" v-model="applyForm[item.selectedVal]" :placeholder="item.placeholder">
					<el-option v-for="opItem in item.dictionaryList" :key="opItem.dictionaryName" :label="opItem.dictionaryName" :value="opItem.dictionaryName">
					</el-option>
				</el-select>

				<!-- 日期选择 -->
				<el-date-picker v-else-if="item.type == 4 || ['birthday'].includes(item.selectedVal)" v-model="applyForm[item.selectedVal]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
				</el-date-picker>

				<!-- 数字输入框 -->
				<el-input-number :controls='false' v-else-if="[2, 3].includes(item.type)" :placeholder='item.placeholder' :max='10**13-1' v-model="applyForm[item.selectedVal]" :precision="item.type== 2 ? 0 : 2"></el-input-number>

				<!-- 附件 -->
				<el-upload v-else-if="item.selectedVal == 'attachments'" accept=".jpg,.jpeg,.png" :limit="3" :action="config.uploadFileUrl" list-type="picture-card" :data="{
					userName: userName,
					fileClass: 'fileImg',
				  }" :on-preview="_handlePictureCardPreview" :on-exceed="_handlePictureCardExceed" :on-success="_handleSuccess" :on-remove="_handleRemove">
					<i class="el-icon-plus"></i>
				</el-upload>

				<!-- 手机号 -->
				<el-input v-else-if="item.selectedVal == 'contactTel'" v-model="applyForm[item.selectedVal]" :maxlength="getInputMaxLength(item)" disabled :placeholder='item.placeholder'></el-input>

				<!-- 地址选择 -->
				<div :class='cantShowForeignAdrSelect ? `adr-sel-form_nopadding` : `adr-sel-form`' v-else-if="item.selectedVal == 'address'">
					<el-cascader filterable v-show='!isForeignAdr' style='width: 100%;' id="addrselect" size="large" :options="cnAddressOptionList" v-model="applyForm[item.selectedVal]" placeholder="请选择 省 / 市 / 区">
					</el-cascader>
					<el-cascader filterable v-show='isForeignAdr' size="large" style='width: 100%;' :options="countryOptionList" v-model="applyForm[item.selectedVal]" placeholder="请选择 国家">
					</el-cascader>
					<div v-if='!cantShowForeignAdrSelect || isForeignAdr' class='adr-type-btn' @click="changeAdrType">{{isForeignAdr?'国内地址':'国外地址'}}</div>
					<el-input style="margin-top: 10px;" v-model="applyForm.detailAddress" autocomplete="off" placeholder="请输入详细地址" maxlength="10" show-word-limit></el-input>
				</div>

				<!-- 文字输入 -->
				<el-input v-else v-model="applyForm[item.selectedVal]" :maxlength="getInputMaxLength(item)" :placeholder='item.placeholder'></el-input>
			</el-form-item>
		</el-form>

		<div class="apply-btn" v-if='isShowForm'>
			<el-button style="width: 40%;" type="primary" @click="submitForm">申请</el-button>
		</div>

		<el-dialog :append-to-body='true' :modal='false' v-if="dialogVisible" :visible.sync="dialogVisible" @close='closeImgPreview'>
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
	import { getParam } from '../../utils/api-utils/api-params.js'
	import addressUtils from '../../utils/api-utils/api-address.js'
	import {
		config
	} from '../../config.js';
	import {
		chinaAreaJson
	} from '../../utils/chinaareajson.js'
	import {
		getOptionListOfSeller,
		getOptionListOfChannel,
		getRegisterApplyDetail,
		addRegisterApply,
		getCustomerInfo
	} from '../../utils/api-utils/api-customer.js'
	import {
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
	import commonUtil from '../../utils/common-utlis.js';
	export default {
		name: 'CheckInApply',
		computed: {
			userName() {
				return localStorage.getItem('SubMemberName') || localStorage.getItem('JackyunUserName')
			},

		},
		props: {
			formHeight: {
				type: String,
				default: "540px"
			},
			isLimitOfCheckIn: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				config: config, //获取url参数
				applyStatusMap: {
					0: 'notAudited',
					1: 'audited',
					2: 'rejected',
					3: 'notApplied',
				}, // 当前申请状态映射				
				applyStatus: "notApplied", // 当前申请状态
				applyStatusText: "您无法查看该页面内容，请联系商家或申请权限", // 当前状态提示文字
				isShowForm: false, // 是否展示表单
				isShowApplyStatusText: false, // 是否展示表单申请状态提示文字
				applyForm: {}, // 表单数据
				applyFormRules: {}, // 表单验证规则
				loginLimitApplySettingList: [], // 后台设置的表单内容
				isForeignAdr: false, // 是否展示国外地址
				cnAddressOptionList: chinaAreaJson,
				countryOptionList: [],
				telForRegister: localStorage.getItem("telForRegister"),
				dialogVisible: false, //图片预览
				dialogImageUrl: '', //预览图片url
				attachList: [], // 附件列表
				isLimitOfPersonalInfo: false, // 是否需要完善信息
				tipTitle: '', // 标题
			}
		},
		created: async function() {
			// 获取参数
			await this.loadParam();

			// 获取申请状态
			await this.getApplyStatus();

			// 补充下拉选项
			await this.compeleteOptionList();

			// 设置表单数据
			this.setFormData();

			// 判断是否需要更新浮窗的状态
			this.refreshFloatApplyTip()

			// 展示表单申请内容
			this.isShowApplyStatusText = true
		},
		methods: {
			/**
			 * 查询 申请状态
			 */
			async getApplyStatus() {
				let tempApplyStatusObj = await getRegisterApplyDetail(this.telForRegister);

				// 当前申请状态映射
				let applyStatusTextMap = {
					notAudited: this.isLimitOfCheckIn ? '已提交申请，等待商家审核通过即可进入商城并下单' : '已提交申请，等待商家审核通过即可查看价格并下单',
					audited: this.isLimitOfCheckIn ? '商家已审核，重新登录即可进入商城' : '商家已审核，重新登录即可查看价格',
					rejected: '商家已驳回申请，可再次申请查看' + (tempApplyStatusObj.rejectReason ? '。驳回原因：' + tempApplyStatusObj.rejectReason : ''),
					notApplied: this.isLimitOfCheckIn ? '您无法查看该页面内容，请联系商家或申请权限' : (this.isLimitOfPersonalInfo ? '请完善信息' : '您无法查看价格，请联系商家或申请权限'),
				}

				this.applyStatus = this.applyStatusMap[tempApplyStatusObj.auditStatus === 0 ? 0 : (tempApplyStatusObj.auditStatus || 3)];
				this.applyStatusText = applyStatusTextMap[this.applyStatus];
				this.applyId = tempApplyStatusObj.applyId || ''
			},

			/**
			 * 设置表单数据
			 */
			async setFormData() {
				// 处理表单内容
				if (['notApplied', 'rejected'].includes(this.applyStatus)) {
					// 手机号赋值
					this.$set(this.applyForm, 'contactTel', this.telForRegister);
					// this.applyForm.contactTel = this.telForRegister;

					this.loginLimitApplySettingList.forEach(item => {
						let ruleMap = {
							email: [{ required: item.isRequired == "1", validator: this.validateOfEmail, trigger: 'blur' }],
							address: [{ required: item.isRequired == "1", validator: this.validateOfAddress, trigger: 'change' }],
							contactTel: [{ required: item.isRequired == "1", validator: this.validateOfTel, trigger: 'blur' }],
							attachments: [{ required: item.isRequired == "1", validator: this.validateOfAttachments, trigger: 'blur' }],
						}
						// 表单验证规则
						let tip = item.selectedVal == 'attachments' ? '请上传' : (['customerChannel', 'salesman', 'gender', 'birthday'].includes(item.selectedVal) || [4, 5, 6].includes(item.type) ? '请选择' : '请输入');
						this.applyFormRules[item.selectedVal] = ruleMap[item.selectedVal] || [{ required: item.isRequired == "1", message: tip + item.showName, trigger: tip == '请选择' ? 'change' : 'blur' }]

						// 补充placeholder
						item.placeholder = item.selectedVal == 'birthday' ? '保存后不可修改' : tip + item.showName;

						// 补充下拉选项
						item.dictionaryList = item.dictionaryList || this.optionObj[item.selectedVal];
					})

					// 必须展示手机号 没有需要补充
					if (!this.loginLimitApplySettingList.find(item => item.selectedVal == "contactTel")) {
						this.loginLimitApplySettingList.unshift({
							selectedVal: 'contactTel',
							type: 0,
							isRequired: '1',
							maxLength: 20,
							showName: "联系电话",
							tipText: "请输入联系电话",
							placeholder: "请输入联系电话",
						})
					}

					this.isShowForm = true;

					// el-select在页面加载时会自动校验一次 取消该次校验结果
					this.$nextTick(() => {
						this.$refs.applyForm.clearValidate();
					})
				}
			},

			/**
			 * 判断是否需要更新浮窗的状态
			 */
			async refreshFloatApplyTip() {
				if (this.applyStatus != 'audited') {
					return
				}

				this.$emit('refreshStatus')
			},

			/**
			 * 补充下拉选项
			 */
			async compeleteOptionList() {
				let sellerOptionsList = !!this.loginLimitApplySettingList.find(item => item && item.selectedVal == 'salesman') && await getOptionListOfSeller() || [];
				let customerChannelOptionsList = !!this.loginLimitApplySettingList.find(item => item && item.selectedVal == 'customerChannel') && await getOptionListOfChannel() || [];
				this.optionObj = {
						salesman: sellerOptionsList.map(item => {
							return {
								dictionaryName: item.realName,
								userId: item.userId
							}
						}),
						gender: [{
							dictionaryName: '男'
						}, {
							dictionaryName: '女'
						}],
						customerChannel: customerChannelOptionsList.map(item => {
							return {
								dictionaryName: item.channelName,
								channelId: item.channelId,
								channelCode: item.channelCode,
							}
						}),
					}

					// 国外地址
					!!this.loginLimitApplySettingList.find(item => item && item.selectedVal == 'address') && this._loadCountryList();
			},

			/**
			 * 邮箱校验规则
			 */
			validateOfAttachments(rule, value, callback) {
				let tempItem = this.loginLimitApplySettingList.find(item => item.selectedVal == 'attachments')
				let isRequired = tempItem && tempItem.isRequired == '1';


				// 必填且没输入
				if (isRequired && this.attachList.length == 0) {
					callback(new Error(tempItem.placeholder));
					return
				} else {
					callback();
				}
			},


			/**
			 * 邮箱校验规则
			 */
			validateOfEmail(rule, value, callback) {
				// 校验规则
				var reg = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_\-\.])+\.([a-zA-Z]{2,8})$/;

				let tempItem = this.loginLimitApplySettingList.find(item => item.selectedVal == 'email')
				let isRequired = tempItem && tempItem.isRequired == '1'

				// 必填且没输入
				if (!value && isRequired) {
					callback(new Error('请输入邮箱'));
					return
				}

				// 非必填 或 已输入 校验格式
				if (value && !reg.test(value)) {
					callback(new Error('邮箱格式错误'));
				} else {
					callback();
				}
			},

			/**
			 * 手机号校验规则
			 */
			validateOfTel(rule, value, callback) {
				let tempItem = this.loginLimitApplySettingList.find(item => item.selectedVal == 'contactTel')
				let isRequired = tempItem && tempItem.isRequired == '1'

				// 必填且没输入
				if (!value && isRequired) {
					callback(new Error(tempItem.placeholder));
					return
				}

				// 非必填 或 已输入 校验格式
				if (value && !this.$utils.checkTel(value)) {
					callback(new Error('手机号格式错误'));
				} else {
					callback();
				}
			},

			/**
			 * 地址校验规则
			 */
			validateOfAddress(rule, value, callback) {
				let tempItem = this.loginLimitApplySettingList.find(item => item.selectedVal == 'address')
				let isRequired = tempItem && tempItem.isRequired == '1'

				// 不是必填直接返回
				if (!isRequired) {
					callback();
				}

				if (!this.applyForm.address || this.applyForm.address.length == 0) {
					callback(new Error('请选择联系地址'));
				} else {
					callback();
				}
			},

			/**
			 * 加载参数
			 */
			async loadParam() {
				let params = await getParam("loginLimitApplySettingList,loginLimitType,cantShowForeignAdrSelect");

				this.loginLimitApplySettingList = JSON.parse(params.loginLimitApplySettingList || '[]');
				this.isLimitOfPersonalInfo = params.loginLimitType == 'auditLimitOfPersonalInfo';
				this.tipTitle = this.isLimitOfPersonalInfo ? '完善注册信息' : '申请查看权限';
				this.loginParams = JSON.parse(localStorage.getItem("loginParams") || '{}');
				this.cantShowForeignAdrSelect = params.cantShowForeignAdrSelect == "1";
				localStorage.removeItem("loginParams");
			},

			/**
			 * 加载参数
			 */
			submitForm() {
				let that = this;
				this.$refs.applyForm.validate((valid, failObj) => {
					if (valid) {
						that.registerApply()
					} else {
						let validArr = Object.values(failObj)
						that.$message.error(((validArr[0] || [])[0] || {}).message)
						return false;
					}
				});
			},

			/**
			 * 提交注册申请
			 */
			async registerApply() {
				// 显示加载中弹窗
				commonUtil.showLoading(this, '申请中');

				// 获取表单填写内容
				let applyContent = this.getApplyContent();

				// 获取需要的创建档案参数 附件 联系地址
				let crmCustomerJson = this.getCrmCustomerJson()

				// 获取业务员id
				let salesmanId = this.applyForm.salesman && (this.optionObj.salesman.find(item => item.dictionaryName == this.applyForm.salesman) || {}).userId;

				// 获取选择的渠道id
				let channelId = this.applyForm.customerChannel && (this.optionObj.customerChannel.find(item => item.dictionaryName == this.applyForm.customerChannel) || {}).channelId;

				// 获取选择的渠道code
				let channelCode = this.applyForm.customerChannel && (this.optionObj.customerChannel.find(item => item.dictionaryName == this.applyForm.customerChannel) || {}).channelCode;

				let errorMsg = await addRegisterApply({
					applyContent: JSON.stringify(applyContent),
					contactTel: this.applyForm.contactTel,
					nickName: this.applyForm.nickName,
					contactName: this.applyForm.contactName,
					salesman: this.applyForm.salesman,
					salesmanId,
					email: this.applyForm.email,
					weChatNo: this.applyForm.weChatNo,
					qq: this.applyForm.qq,
					remark: this.applyForm.remark,
					address: this.addressForRegister || '',
					crmCustomerJson,
					channelId,
					channelCode,
					channelName: this.applyForm.customerChannel,
					applyId: this.applyId,
					pcOpenId: localStorage.getItem("pcOpenIdForRegister") || ''
				})

				// 关闭加载中弹窗
				commonUtil.closeLoading();

				// 申请失败 提示原因
				if (errorMsg) {
					this.$message.error(errorMsg)
					return
				}

				// 更改提示文字
				this.applyStatusText = '已提交申请，等待商家审核通过即可进入商城并下单';
				this.isShowForm = false;

				// 如果是 完善信息 需要重新获取客户信息
				this.isLimitOfPersonalInfo && await getCustomerInfo(this.loginParams, true);

				// 通知父组件修改状态
				this.$emit('applySuccess', { isNeedRefreshUserName: this.isLimitOfPersonalInfo });
			},

			/**
			 * 获取需要的创建档案参数 附件 联系地址
			 */
			getCrmCustomerJson() {
				let contactsModelArr = this.getContactsModelArr();
				let crmCustomerJson = {
					enclosureArr: this.getEnclosureJson(),
					contactsModelArr,
					country: contactsModelArr[0].country,
					state: contactsModelArr[0].state,
					city: contactsModelArr[0].city,
					district: contactsModelArr[0].district,
					detailedAddress: contactsModelArr[0].detailedAddress,
				}

				return crmCustomerJson
			},

			/**
			 * 获取联系地址
			 */
			getContactsModelArr() {
				// 省市区信息
				let addressInfo = this.applyForm.address;
				let state
				let city
				let district

				if (addressInfo) {
					state = CodeToText[addressInfo[0]];
					city = CodeToText[addressInfo[1]];
					district = CodeToText[addressInfo[2]];
					city = this._getCityText(state, city);
				}

				let contactsModelArr = [{
					country: this.isForeignAdr ? (this.applyForm[applySettinItem.selectedVal] || []).join('') : "中国",
					state,
					city,
					district,
					detailedAddress: this.applyForm.detailAddress || '',
					contactsName: this.applyForm.contactName,
					contactTel: this.applyForm.contactTel,
					contactsPhone: this.applyForm.contactTel,
					contactsMobile: this.applyForm.contactTel,
					weiXin: this.applyForm.weChatNo,
					nickname: this.applyForm.nickName,
					email: this.applyForm.email,
					qq: this.applyForm.qq,
					isDefault: 0,
				}]

				return contactsModelArr
			},


			/**
			 * 获取附件信息
			 */
			getEnclosureJson() {
				// 附件
				if (this.attachList.length == 0) {
					return
				}
				let enclosureJson = []
				this.attachList.forEach(item => {
					let fileName = item.replace(/^.*[\\\/]/, '');
					enclosureJson.push({
						enclosureType: 3,
						enclosureName: fileName,
						downLoadUrl: item,
					})
				})

				return enclosureJson
			},

			/**
			 * 获取表单内容
			 */
			getApplyContent() {
				let applyContent = [];
				this.loginLimitApplySettingList.forEach(item => {
					applyContent.push({
						name: item.showName,
						fieldName: item.selectedVal,
						isAttachment: item.selectedVal == 'attachments',
						isMultiSelect: item.type == 6,
						value: this.getApplyContentValue(item)
					})
				})

				return applyContent;
			},

			/**
			 * 获取表单填入值
			 */
			getApplyContentValue(applySettinItem) {
				let isMultiSelect = applySettinItem.type == 6;
				let isAttachment = applySettinItem.selectedVal == 'attachments';
				let isAddress = applySettinItem.selectedVal == 'address';

				if (isAddress && !this.isForeignAdr && this.applyForm[applySettinItem.selectedVal]) {
					// 详细地址
					let detailAddress = this.applyForm.detailAddress || ''

					// 省市区信息
					let addressInfo = this.applyForm[applySettinItem.selectedVal];
					let province = CodeToText[addressInfo[0]];
					let city = CodeToText[addressInfo[1]];
					let district = CodeToText[addressInfo[2]];
					city = this._getCityText(province, city);

					this.addressForRegister = province + city + district + detailAddress
					return province + city + district + detailAddress
				} else if (isAddress && this.isForeignAdr) {
					this.addressForRegister = (this.applyForm[applySettinItem.selectedVal] || []).join('') + (this.applyForm.detailAddress || '')
				}

				return isMultiSelect ? (this.applyForm[applySettinItem.selectedVal] || []).join(",") : (isAttachment ? this.attachList : this.applyForm[applySettinItem.selectedVal])
			},

			//编码转文字
			_getCityText(province, city) {
				let cityName = city;
				let specialCity = "北京市，天津市，上海市，重庆市"; //直辖市
				if (province && specialCity.indexOf(province) > -1) {
					cityName = province;
					if (province == "重庆市" && city == "县") {
						cityName = '县';
					}
				}
				return cityName;
			},

			/**
			 * 附件上传
			 */
			_handlePictureCardPreview(response, file, fileList) {
				this.dialogImageUrl = response.response.error_info;
				this.dialogVisible = true;
			},
			_handlePictureCardExceed(files, fileList) {
				this.$message.error("附件数量不可超出3个")
			},
			_handleSuccess(response, file, fileList) {
				if (response.error_code == "0") {
					this.attachList.push(response.error_info)
				}
			},
			_handleRemove(file, fileList) {
				this.attachList = fileList.map(item => item.response.error_info)
			},

			/**
			 * 获取输入长度限制
			 */
			getInputMaxLength(inputData) {
				let lengthMap = {
					nickName: 100,
					contactName: 100,
					weChatNo: 20,
					qq: 20,
					remark: 500,
				};

				return inputData.type != 0 ? 100 : lengthMap[inputData.selectedVal];
			},


			/**
			 * 加载国家列表
			 */
			async _loadCountryList() {
				// 优先缓存中数据
				let countryList = localStorage.getItem("countryList");
				if (countryList && countryList != '[]') {
					return this.countryOptionList = JSON.parse(countryList);
				}

				countryList = await addressUtils.getCountryList();
				// 渲染到页面并添加到缓存
				this.countryOptionList = countryList;
			},

			/**
			 * 切换地址
			 */
			changeAdrType() {
				// 地址赋值
				this.applyForm.address = undefined;

				this.isForeignAdr = !this.isForeignAdr;
			},


			/**
			 * 关闭图片预览弹窗
			 */
			closeImgPreview() {
				this.dialogVisible = false;

			},



		},
	}
</script>

<style scoped>
	.apply-content {
		width: 800px;
		margin: 0 auto;
	}

	.apply-tip {
		background-color: white;
		border-radius: 10px;
		padding: 30px 0 45px;
		border: 1px solid #f9f9f9;
		box-sizing: border-box;
	}

	.tip-title {
		text-align: center;
		font-weight: 600;
		font-size: 20px;
	}

	.tip-text {
		text-align: center;
		color: #999;
		margin-top: 20px;
		padding: 0 10px;
		word-break: break-all;
	}

	.apply-form {
		background-color: white;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		margin-top: 20px;
		padding: 10px 40px;
		height: 550px;
		overflow: auto;
		position: relative;
		padding-bottom: 40px;
		border: 1px solid #f9f9f9;
		border-bottom: unset;
		box-sizing: border-box;
	}

	.form-item {
		background-color: white;
		display: flex;
		flex-direction: column;
	}

	.apply-btn {
		margin: 0 auto;
		background-color: white;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		padding: 45px 0;
		text-align: center;
	}

	.adr-sel-form {
		padding-right: 60px;
		position: relative;
	}

	.adr-type-btn {
		font-size: 12px;
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
	}

	/deep/.el-form-item__label {
		text-align: left !important;
	}

	/deep/.el-select,
	.el-input-number {
		display: block;
		width: auto;
	}

	/deep/.el-input-number .el-input__inner {
		text-align: left;
	}

	/deep/ .el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100% !important;
	}
</style>